import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/contact-inquiries',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::index
* @see app/Http/Controllers/ContactInquiryController.php:18
* @route '/dashboard/contact-inquiries'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
export const show = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/dashboard/contact-inquiries/{inquiry}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
show.url = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { inquiry: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { inquiry: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            inquiry: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        inquiry: typeof args.inquiry === 'object'
        ? args.inquiry.id
        : args.inquiry,
    }

    return show.definition.url
            .replace('{inquiry}', parsedArgs.inquiry.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
show.get = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
show.head = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
const showForm = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
showForm.get = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::show
* @see app/Http/Controllers/ContactInquiryController.php:50
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
showForm.head = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\ContactInquiryController::sendEmail
* @see app/Http/Controllers/ContactInquiryController.php:84
* @route '/dashboard/contact-inquiries/{inquiry}/send-email'
*/
export const sendEmail = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendEmail.url(args, options),
    method: 'post',
})

sendEmail.definition = {
    methods: ["post"],
    url: '/dashboard/contact-inquiries/{inquiry}/send-email',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactInquiryController::sendEmail
* @see app/Http/Controllers/ContactInquiryController.php:84
* @route '/dashboard/contact-inquiries/{inquiry}/send-email'
*/
sendEmail.url = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { inquiry: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { inquiry: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            inquiry: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        inquiry: typeof args.inquiry === 'object'
        ? args.inquiry.id
        : args.inquiry,
    }

    return sendEmail.definition.url
            .replace('{inquiry}', parsedArgs.inquiry.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactInquiryController::sendEmail
* @see app/Http/Controllers/ContactInquiryController.php:84
* @route '/dashboard/contact-inquiries/{inquiry}/send-email'
*/
sendEmail.post = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendEmail.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::sendEmail
* @see app/Http/Controllers/ContactInquiryController.php:84
* @route '/dashboard/contact-inquiries/{inquiry}/send-email'
*/
const sendEmailForm = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendEmail.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::sendEmail
* @see app/Http/Controllers/ContactInquiryController.php:84
* @route '/dashboard/contact-inquiries/{inquiry}/send-email'
*/
sendEmailForm.post = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendEmail.url(args, options),
    method: 'post',
})

sendEmail.form = sendEmailForm

/**
* @see \App\Http\Controllers\ContactInquiryController::approve
* @see app/Http/Controllers/ContactInquiryController.php:175
* @route '/dashboard/contact-inquiries/{inquiry}/approve'
*/
export const approve = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

approve.definition = {
    methods: ["post"],
    url: '/dashboard/contact-inquiries/{inquiry}/approve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactInquiryController::approve
* @see app/Http/Controllers/ContactInquiryController.php:175
* @route '/dashboard/contact-inquiries/{inquiry}/approve'
*/
approve.url = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { inquiry: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { inquiry: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            inquiry: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        inquiry: typeof args.inquiry === 'object'
        ? args.inquiry.id
        : args.inquiry,
    }

    return approve.definition.url
            .replace('{inquiry}', parsedArgs.inquiry.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactInquiryController::approve
* @see app/Http/Controllers/ContactInquiryController.php:175
* @route '/dashboard/contact-inquiries/{inquiry}/approve'
*/
approve.post = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: approve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::approve
* @see app/Http/Controllers/ContactInquiryController.php:175
* @route '/dashboard/contact-inquiries/{inquiry}/approve'
*/
const approveForm = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::approve
* @see app/Http/Controllers/ContactInquiryController.php:175
* @route '/dashboard/contact-inquiries/{inquiry}/approve'
*/
approveForm.post = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: approve.url(args, options),
    method: 'post',
})

approve.form = approveForm

/**
* @see \App\Http\Controllers\ContactInquiryController::destroy
* @see app/Http/Controllers/ContactInquiryController.php:234
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
export const destroy = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/contact-inquiries/{inquiry}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ContactInquiryController::destroy
* @see app/Http/Controllers/ContactInquiryController.php:234
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
destroy.url = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { inquiry: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { inquiry: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            inquiry: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        inquiry: typeof args.inquiry === 'object'
        ? args.inquiry.id
        : args.inquiry,
    }

    return destroy.definition.url
            .replace('{inquiry}', parsedArgs.inquiry.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactInquiryController::destroy
* @see app/Http/Controllers/ContactInquiryController.php:234
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
destroy.delete = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::destroy
* @see app/Http/Controllers/ContactInquiryController.php:234
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
const destroyForm = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ContactInquiryController::destroy
* @see app/Http/Controllers/ContactInquiryController.php:234
* @route '/dashboard/contact-inquiries/{inquiry}'
*/
destroyForm.delete = (args: { inquiry: string | number | { id: string | number } } | [inquiry: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const contactInquiries = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    sendEmail: Object.assign(sendEmail, sendEmail),
    approve: Object.assign(approve, approve),
    destroy: Object.assign(destroy, destroy),
}

export default contactInquiries